<div data-testid="api-keys-expiring" class="api-keys-expiring">
  <div class="api-keys-expiring__header">
    <div class="api-keys-expiring__titles">
      <h4 data-testid="keys-title" class="api-keys-expiring__title">{{ title }}</h4>
      <p data-testid="keys-description" class="api-keys-expiring__description">{{ headline }}</p>
    </div>
  </div>
  @if (failed) {
    <app-admin-dashboard-empty data-testid="keys-failed" icon="fa-regular fa-circle-exclamation" [title]="failedTitle"
                               body="Try again, or pick another period." [compact]="true"></app-admin-dashboard-empty>
  } @else if (rows.length) {
    <ul data-testid="keys-list" class="adb-list">
      @for (row of listed; track $index) {
        <li data-testid="key-row" class="adb-list__row" [title]="row.companyId">
          <span class="adb-list__main">
            <button type="button" data-testid="key-company" class="adb-list__name" (click)="open360(row.companyId)">{{ row.companyName }}</button>
            @if (keyLine(row); as line) {
              <span data-testid="key-label" class="adb-list__reason"
                    [title]="row.issuedTo ? 'Issued to ' + row.issuedTo : line">@if (row.keyLabel) {<span data-testid="key-mask" class="adb-mono">{{ row.keyLabel }}</span>}{{ apisText(row) }}</span>
            } @else if (row.issuedTo) {
              <span data-testid="key-issued-to" class="adb-list__reason" [title]="row.issuedTo">{{ row.issuedTo }}</span>
            }
          </span>
          <span data-testid="key-when" class="adb-list__when" [class.adb-bad]="isLapsed(row.daysLeft)" [class.adb-warn]="isSoon(row.daysLeft)"
                [title]="(isLapsed(row.daysLeft) ? 'Expired ' : 'Expires ') + (row.expiryDate | date:'d MMM yyyy':'UTC')">{{ whenText(row.daysLeft) }}</span>
        </li>
      }
    </ul>
  } @else if (loaded) {
    <app-admin-dashboard-empty data-testid="empty" icon="fa-regular fa-key" title="No keys expiring"></app-admin-dashboard-empty>
  }
</div>
